import useFilters from 'modules/core/components/DataTable/hooks/useFilters'

import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'
import {
  buildPurchaseRequestsOverdueCounterInsightWidget,
  buildPurchaseRequestsPendingCounterInsightWidget,
  buildPurchaseRequestsTotalCounterInsightWidget,
} from 'modules/procurement/components/Widgets/PurchaseRequestsSingleCounterWidget'

import { PurchaseRequestsInsightsProps } from './types'

export const PurchaseRequestsInsights = ({
  companyId,
  onlyMyPendingApprovals = false,
  search,
}: PurchaseRequestsInsightsProps) => {
  const { getFiltersVariables } = useFilters()
  const dataTableFilters = getFiltersVariables().filter ?? {}

  return (
    <DataTableWidgetInsights
      useBox
      widgets={[
        buildPurchaseRequestsTotalCounterInsightWidget({
          queryArgs: { companyId, onlyMyPendingApprovals, search },
          filters: dataTableFilters,
        }),
        buildPurchaseRequestsPendingCounterInsightWidget({
          queryArgs: { companyId, onlyMyPendingApprovals, search },
          filters: dataTableFilters,
        }),
        buildPurchaseRequestsOverdueCounterInsightWidget({
          queryArgs: { companyId, onlyMyPendingApprovals, search },
          filters: dataTableFilters,
        }),
      ]}
      widgetWidth="full"
    />
  )
}
